import { getGeschaeftsart, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, Immobilie } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { Vertragsgrund } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { VhvActions } from '../vhvActions';

export interface Vorbelegungen {
  adresseImmobilieVorbelegt: boolean;
  versicherungsnehmerVorbelegt: boolean;
  activateElementar?: boolean;
}

export const vorbelegungenReducer = function (
  sectionState: Vorbelegungen = null,
  action: AnyAction,
  appState: IAppState,
): Vorbelegungen {
  switch (action.type) {
    case GlobalActions.IMMOBILIE_UEBERNEHMEN: {
      const immobilie: Immobilie = action.payload.immobilie;
      if (
        action.payload.appId !== App.VHV_V2 ||
        action.payload.angebotsId !== appState.angebotsId ||
        !immobilie
      ) {
        return sectionState;
      }

      return {
        adresseImmobilieVorbelegt: true,
        versicherungsnehmerVorbelegt: sectionState.versicherungsnehmerVorbelegt,
        activateElementar:
          getGeschaeftsart(appState.vertragsoptionen) === Vertragsgrund.ERSATZGESCHAEFT &&
          immobilie.hasElementar,
      };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      return {
        ...sectionState,
        versicherungsnehmerVorbelegt: true,
      };
    }
    case VhvActions.PLZ_CHANGED: {
      return {
        ...sectionState,
        adresseImmobilieVorbelegt: false,
      };
    }
    default:
      return sectionState;
  }
};
